import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=b566895c&scoped=true"
import script from "./PopupDialog.vue?vue&type=script&lang=ts"
export * from "./PopupDialog.vue?vue&type=script&lang=ts"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=b566895c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b566895c",
  null
  
)

export default component.exports